import { useNavigate } from "react-router-dom";
import { BRAND_LOGO } from "../../config/constants";

export function HeroSection() {
  const navigate = useNavigate();
  
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden" data-testid="hero-section">
      <div className="absolute inset-0 bg-gradient-to-b from-black via-zinc-900 to-black" />
      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto pt-16">
        <img src={BRAND_LOGO} alt="Fresh Po'Boy Streetwear LLC" className="h-48 sm:h-64 lg:h-72 w-auto mx-auto mb-8" />
        <h1 className="font-bebas text-5xl sm:text-7xl lg:text-8xl text-white tracking-tight leading-none mb-4">
          Street Style<br /><span className="text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-cyan-400">Redefined</span>
        </h1>
        <p className="text-white/60 text-lg sm:text-xl max-w-xl mx-auto mb-8">Premium streetwear for those who dare to stand out. T-Shirts, Hoodies & Sweaties.</p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button onClick={() => navigate('/shop')} className="px-8 py-4 bg-red-600 text-white font-semibold hover:bg-red-500 transition-colors" data-testid="shop-now-btn">Shop Now</button>
          <button onClick={() => navigate('/sports')} className="px-8 py-4 border-2 border-cyan-400 text-cyan-400 font-semibold hover:bg-cyan-400 hover:text-black transition-colors" data-testid="sports-collection-btn">Sports Collection</button>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 py-4 bg-gradient-to-r from-red-600 via-red-500 to-red-600 overflow-hidden">
        <div className="animate-marquee whitespace-nowrap">
          <span className="text-white font-semibold mx-4">10% OFF EVERYTHING • Free Shipping Over $100 • New Drops Weekly • Exclusive Designs • 10% OFF EVERYTHING • Free Shipping Over $100 • New Drops Weekly •</span>
        </div>
      </div>
    </section>
  );
}
